import React, { useState, useEffect } from 'react';
import { FaGooglePlay, FaApple } from 'react-icons/fa';
import './HeroSection.css';

const HeroSection = () => {
  const sebi="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/sebi.gif";
  const goi="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/gov.png";
  const bse="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/spbse.png";
  const amfi="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/amfi.png";
  const phoneImage = "https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/phon+(1).png";

  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [prevTextIndex, setPrevTextIndex] = useState(2);
  const texts = [
    "Expertly managed Mutual Funds",
    "Stocks",
    "Portfolio Management Services"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevTextIndex(currentTextIndex);
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [currentTextIndex]);


  return (
    <div className="w-full flex flex-col justify-center bg-[#E8EEF6] font-['General Sans'] overflow-hidden" style={{
      minHeight: 'calc(100vh - 80px)',
      paddingTop: 'clamp(5rem, 12vh, 8rem)'
    }}>
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12 items-start">
          {/* Left Column - Text Content */}
          <div className="relative">
            <div className="space-y-4 sm:space-y-5 md:space-y-6">
              {/* Main Heading */}
              <h1 className="text-[#113262] text-[28px] sm:text-[30px] md:text-[32px] leading-tight font-bold max-w-xl">
                Grow & Protect Wealth. Through Scientific Investment Strategies.
              </h1>

              {/* Subheading */}
              <p className="text-[#436FB0] text-[18px] sm:text-[19px] md:text-[20px] leading-snug max-w-lg">
                Join 10,000+ families who trust our independent research-backed approach to achieve their financial goals.
              </p>

              {/* Animated Services Text */}
              <div className="text-[#1C52A0] text-[24px] leading-[32px] font-medium h-[32px] overflow-hidden relative">
                <div className="animation-wrapper">
                  <div key={`prev-${prevTextIndex}`} className="slide-out">
                    {texts[prevTextIndex]}
                  </div>
                  <div key={`current-${currentTextIndex}`} className="slide-in">
                    {texts[currentTextIndex]}
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-col space-y-3 md:space-y-4 pt-2 md:pt-4">
                {/* Primary CTA Button */}
                <a
                  href="https://app.maxiomwealth.com/portfolio"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full sm:w-auto bg-[#113262] border-2 border-[#113262] text-center text-white px-6 sm:px-8 md:px-12 py-3 md:py-4 rounded-lg text-[15px] md:text-[16px] leading-normal font-medium hover:bg-[#143970] transition-colors duration-300 shadow-sm"
                >
                  Get Free Portfolio Health Check
                </a>

                {/* Secondary CTA Button */}
                <a 
                 href="https://club.maxiomwealth.com/goals/finplan/create"
                 target="_blank"
                  rel="noopener noreferrer"
                 className="w-full sm:w-auto border-2 border-[#113262] text-[#113262] text-center px-6 sm:px-8 md:px-12 py-3 md:py-4 rounded-lg text-[15px] md:text-[16px] leading-normal font-medium hover:bg-[#E8EEF6] transition-colors duration-300">
                  Start Goal Based Investment
                </a>
              </div>
            </div>

            {/* Enhanced Accreditations Section - Only visible on desktop */}
            <div className="absolute w-full hidden lg:block" style={{ top: '100%', marginTop: '5rem' }}>
              <div className="p-3">
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={sebi} alt="SEBI" className="w-12 h-12" loading="lazy" />
                    <div>
                      <span className="text-[#113262] text-[11px] font-medium block leading-tight">
                        SEBI Registered
                      </span>
                      <span className="text-[#436FB0] text-[10px] block leading-tight">Investment Advisor</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={amfi} alt="AMFI" className="w-10 h-10" loading="lazy" />
                    <div>
                      <span className="text-[#113262] text-[11px] font-medium block leading-tight">
                      AMFI registered
                      </span>
                      <span className="text-[#436FB0] text-[10px] block leading-tight">MF Distributor</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={goi} alt="SEBI" className="w-10 h-14 -mt-2" loading="lazy"/>
                    <div>
                      <span className="text-[#113262] text-[11px] font-medium block leading-tight">
                        Govt of India
                      </span>
                      <span className="text-[#436FB0] text-[10px] block leading-tight">DIPP & MSME Registered</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={bse} alt="SEBI" className="w-14 h-14 -mt-5" loading="lazy"/>
                    <div>
                      <span className="text-[#113262] text-[11px] font-medium block leading-tight">
                        BSE Star
                      </span>
                      <span className="text-[#436FB0] text-[10px] block leading-tight">Registered</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Mobile App Screenshot */}
          <div className="relative flex flex-col items-center justify-center mt-2 sm:mt-4 md:mt-6">
            {/* Mobile phone image from the specified URL */}
            <img 
              src={phoneImage} 
              alt="Maxiom Wealth App" 
              className="w-[280px] sm:w-[340px] md:w-[360px] object-contain"
            />

            {/* App Store Buttons */}
            <div className="flex justify-center gap-3 sm:gap-4 mt-6 sm:mt-8">
              <a
                href="https://apps.apple.com/in/app/maxiom-wealth-advisory/id6443719443"
                className="flex items-center space-x-1.5 sm:space-x-2 bg-[#1C52A0] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-[#1C52A0] transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <FaApple className="w-5 h-5 sm:w-6 sm:h-6" />
                <div className="flex flex-col items-start">
                  <span className="text-xs sm:text-sm font-semibold leading-tight">App Store</span>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=in.jama.app"
                className="flex items-center space-x-1.5 sm:space-x-2 bg-[#1C52A0] text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg hover:bg-[#1C52A0] transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <FaGooglePlay className="w-4 h-4 sm:w-5 sm:h-5" />
                <div className="flex flex-col items-start">
                  <span className="text-xs sm:text-sm font-semibold leading-tight">Google Play</span>
                </div>
              </a>
            </div>
            
            {/* Mobile/Tablet Accreditations Section - Only visible on mobile and tablet */}
            <div className="mt-8 w-full lg:hidden">
              <div className="p-3">
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={sebi} alt="SEBI" className="w-10 h-10 sm:w-12 sm:h-12" />
                    <div>
                      <span className="text-[#113262] text-[10px] sm:text-[11px] font-medium block leading-tight">
                        SEBI Registered
                      </span>
                      <span className="text-[#436FB0] text-[9px] sm:text-[10px] block leading-tight">Investment Advisor</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={amfi} alt="AMFI" className="w-8 h-8 sm:w-10 sm:h-10" />
                    <div>
                      <span className="text-[#113262] text-[10px] sm:text-[11px] font-medium block leading-tight">
                      AMFI registered
                      </span>
                      <span className="text-[#436FB0] text-[9px] sm:text-[10px] block leading-tight">MF Distributor</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={goi} alt="SEBI" className="w-8 h-10 sm:w-10 sm:h-14 -mt-1 sm:-mt-2" />
                    <div>
                      <span className="text-[#113262] text-[10px] sm:text-[11px] font-medium block leading-tight">
                        Govt of India
                      </span>
                      <span className="text-[#436FB0] text-[9px] sm:text-[10px] block leading-tight">DIPP & MSME Registered</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 bg-[#E8EEF6]/70 p-2 rounded-lg">
                    <img src={bse} alt="SEBI" className="w-12 h-12 sm:w-14 sm:h-14 -mt-3 sm:-mt-5" />
                    <div>
                      <span className="text-[#113262] text-[10px] sm:text-[11px] font-medium block leading-tight">
                        BSE Star
                      </span>
                      <span className="text-[#436FB0] text-[9px] sm:text-[10px] block leading-tight">Registered</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;